import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { FileText, Check, Calendar } from "@phosphor-icons/react";

const Contract = () => {
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/artist/contract")
      .then((r) => setContract(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-2">
          <FileText size={26} className="text-[#E11D48]" />
          <p className="text-xs uppercase tracking-[0.3em] text-[#E11D48] font-bold">Espace privé artiste</p>
        </div>
        <h1 className="font-display font-black text-4xl tracking-tight mb-3">Mon contrat</h1>
        <p className="text-zinc-400 mb-8">Confidentiel — votre exemplaire horodaté du contrat de partenariat XooKmédia.</p>

        {loading && <p className="text-zinc-500">Chargement...</p>}
        {!loading && !contract && <p className="text-zinc-400">Aucun contrat trouvé.</p>}
        {contract && (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
              <div className="p-4 rounded-lg border border-white/10 bg-[#0f0f10]">
                <div className="text-xs uppercase tracking-widest text-zinc-500">Version</div>
                <div className="font-display font-bold text-xl mt-1">v{contract.version}</div>
              </div>
              <div className="p-4 rounded-lg border border-white/10 bg-[#0f0f10]">
                <div className="text-xs uppercase tracking-widest text-zinc-500">Statut</div>
                <div className="font-display font-bold text-xl mt-1 text-[#10B981] flex items-center gap-1">
                  <Check weight="bold" size={18} /> Signé
                </div>
              </div>
              <div className="p-4 rounded-lg border border-white/10 bg-[#0f0f10]">
                <div className="text-xs uppercase tracking-widest text-zinc-500">Part artiste</div>
                <div className="font-display font-bold text-xl mt-1 text-[#10B981]">
                  {(100 - contract.platform_fee_percent).toFixed(0)}%
                </div>
              </div>
              <div className="p-4 rounded-lg border border-white/10 bg-[#0f0f10]">
                <div className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-1"><Calendar size={12}/> Signé le</div>
                <div className="font-bold text-sm mt-1">{new Date(contract.signed_at).toLocaleString("fr-FR")}</div>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-[#0f0f10] p-8">
              <pre data-testid="contract-detail-text" className="whitespace-pre-wrap text-sm text-zinc-300 font-sans leading-relaxed">
                {contract.text}
              </pre>
              <div className="mt-8 pt-6 border-t border-white/5 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#10B981]/20 flex items-center justify-center">
                  <Check weight="bold" size={24} className="text-[#10B981]" />
                </div>
                <div>
                  <div className="font-bold">Auto-signé électroniquement</div>
                  <div className="text-xs text-zinc-500 font-mono">
                    RIB : {contract.rib_snapshot} • {new Date(contract.signed_at).toISOString()}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Contract;
